module.exports = __webpack_public_path__ + "img/by.7813b57.svg";